module.exports = __webpack_public_path__ + "static/media/tag-light.ed3f2701.svg";